import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, Shield, X } from 'lucide-react';
import { grantConsent, denyConsent } from '../hooks/useAnalytics';
export function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  useEffect(() => {
    // Check if user has already made a choice
    const consentChoice = localStorage.getItem('analytics_consent');
    const doNotTrack = navigator.doNotTrack === '1' || (window as any).doNotTrack === '1' || (navigator as any).msDoNotTrack === '1';
    // Show banner immediately if no choice made and DNT is not enabled
    if (consentChoice === null && !doNotTrack) {
      setShowBanner(true);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem('analytics_consent', 'true');
    grantConsent(); // Update Google Consent Mode v2
    setShowBanner(false);
  };
  const handleDecline = () => {
    localStorage.setItem('analytics_consent', 'false');
    denyConsent(); // Update Google Consent Mode v2
    setShowBanner(false);
  };
  return <AnimatePresence data-id="element-7">
      {showBanner && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6" data-id="element-8">
          <div className="max-w-7xl mx-auto" data-id="element-9">
            <div className="bg-white rounded-2xl shadow-2xl border border-gray-200" data-id="element-10">
              <div className="p-6 md:p-8" data-id="element-11">
                <div className="flex flex-col md:flex-row md:items-center gap-6" data-id="element-12">
                  {/* Icon and Message */}
                  <div className="flex items-start gap-4 flex-1" data-id="element-13">
                    <div className="flex-shrink-0" data-id="element-14">
                      <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center" data-id="element-15">
                        <Cookie className="w-6 h-6 text-white" data-id="element-16" />
                      </div>
                    </div>
                    <div className="flex-1" data-id="element-17">
                      <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2" data-id="element-18">
                        We Value Your Privacy
                      </h3>
                      <p className="text-sm md:text-base text-gray-600 leading-relaxed" data-id="element-19">
                        We use cookies and analytics to improve your experience.
                        Your data is anonymized and we respect your privacy
                        choices.
                        {showDetails && <span className="block mt-3 text-sm text-gray-500" data-id="element-20">
                            We implement Google Consent Mode v2 for privacy
                            compliance. IP addresses are anonymized, and we
                            respect Do Not Track settings.
                          </span>}
                      </p>
                    </div>
                  </div>

                  {/* Actions */}
                  <div className="flex flex-col sm:flex-row gap-3 md:flex-shrink-0" data-id="element-21">
                    <button onClick={handleAccept} className="px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-xl hover:shadow-lg hover:shadow-blue-500/30 transition-all duration-300 whitespace-nowrap" data-id="element-22">
                      Accept All
                    </button>
                    <button onClick={handleDecline} className="px-6 py-3 bg-gray-100 text-gray-700 font-semibold rounded-xl hover:bg-gray-200 transition-all duration-300 whitespace-nowrap" data-id="element-23">
                      Decline
                    </button>
                    <button onClick={() => setShowDetails(!showDetails)} className="px-4 py-3 text-gray-600 font-medium hover:text-gray-900 transition-colors whitespace-nowrap text-sm" data-id="element-24">
                      {showDetails ? 'Hide Details' : 'Learn More'}
                    </button>
                  </div>
                </div>

                {/* Privacy Policy Link */}
                <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-25">
                  <p className="text-xs text-gray-500 text-center md:text-left" data-id="element-26">
                    By accepting, you agree to our use of analytics cookies. See
                    our{' '}
                    <a href="https://spaceport.xyz/privacypolicy" className="underline hover:text-gray-700 font-medium" target="_blank" rel="noopener noreferrer" data-id="element-27">
                      Privacy Policy
                    </a>{' '}
                    for details.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}